module.exports = __webpack_public_path__ + "img/breslau-kommers.519f3a7c.jpg";